import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import { useChat } from '@context/chat.context';
import clsx from 'clsx';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './chat-form.module.scss';

let timeout = null;
const limitCharacter = 500;

type ChatFormProps = {
  onSubmit?: () => void;
};

const ChatForm: React.FC<ChatFormProps> = (props) => {
  const { onSubmit } = props;

  const { t } = useTranslation();
  const { t: tA11y } = useTranslation('a11y');
  const { channelError, tokenError, scrollToBottom, handleSendingMessage, senderBan, receiverBan, channel, mode } =
    useChat();

  const chatMsg = useRef(null);

  const [currentMessage, setCurrentMessage] = useState<string>('');

  const isChatAllowed = !(
    senderBan.channel.banned ||
    senderBan.global.banned ||
    receiverBan.channel.banned ||
    receiverBan.global.banned ||
    channelError ||
    tokenError
  );

  const adjustToContent = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      chatMsg.current.style.height = 'auto';
      chatMsg.current.style.height = `${chatMsg.current.scrollHeight}px`;
      scrollToBottom(mode);
    }, 300);
  };

  const submit = () => {
    if (currentMessage.length < limitCharacter) {
      onSubmit?.();
      handleSendingMessage(channel, currentMessage);
      setCurrentMessage('');
      chatMsg.current.style.height = 'auto';
    }
  };

  return (
    <div
      data-cy="chat-blank-footer"
      className={isChatAllowed ? styles.chat__bottom : ''}
    >
      <div
        className={clsx(
          styles.chat__insertion,
          currentMessage.length >= limitCharacter && styles.chat__insertion__exceed,
        )}
      >
        <p className={clsx(styles.chat__insertion__error, 'vc-text-xs')}>
          {t('CHAT.FORM.MSG_EXCEED', {
            limitCharacter,
          })}
        </p>
        {isChatAllowed && (
          <>
            <textarea
              ref={chatMsg}
              name="message"
              className={clsx(styles.chat__insertion__msg, 'vc-text-m')}
              placeholder={t('CHAT.FORM.PLACEHOLDER_WRITE')}
              rows={1}
              maxLength={limitCharacter}
              value={currentMessage}
              onChange={(e) => {
                adjustToContent();
                setCurrentMessage(e.target.value);
              }}
              data-cy="chat-form-textarea"
            />
            <Button
              type="submit"
              disableDefaultStyling
              className={styles.chat__insertion__send}
              disabled={currentMessage.length >= limitCharacter || currentMessage.length === 0}
              onClick={submit}
              data-cy="chat-form-send-button"
            >
              <Icon
                className={styles.chat__insertion__send__svg}
                name="send"
                aria-label={tA11y('A11Y.CHAT.SEND_MESSAGE')}
              />
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ChatForm;
